$(function () {
    (async () => {
        try {
            await Promise.all([
                import("./global"),
                import("bootstrap/js/dist/collapse"),
                import("simplelightbox"),
            ]);
            await Promise.all([
                import("./index"),
                import("./projects"),
                import("./header"),
                import("./starfield"),
                import("./sounds"),
                import("./theme"),
                import("./game"),
                import("./playground"),
            ]);
        } catch (error) {
            console.error("An error occurred during import:", error);
        }
    })();
});
